import { render, staticRenderFns } from "./TheCookieBanner.vue?vue&type=template&id=45b8a698&scoped=true&"
import script from "./TheCookieBanner.vue?vue&type=script&lang=js&"
export * from "./TheCookieBanner.vue?vue&type=script&lang=js&"
import style0 from "./TheCookieBanner.vue?vue&type=style&index=0&id=45b8a698&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b8a698",
  null
  
)

export default component.exports